import { useEffect, useState } from 'react';

export function useAuditTimeseries(params = {}) {
	const [data, setData] = useState(null);

	useEffect(() => {
		const url = new URL(`${import.meta.env.VITE_APP_API_URL}/audit/timeseries`, window.location.origin);
		Object.entries(params).forEach(([k, v]) => {
			if (v !== undefined && v !== null && v !== '') {
				url.searchParams.set(k, String(v));
			}
		});

		fetch(url.toString())
			.then(r => r.json())
			.then(setData)
			.catch(err => {
				setData({ error: true, message: err?.message || 'Failed to load' });
			});
	}, [JSON.stringify(params)]);

	return data;
}
